import { isEqual, memoize } from 'lodash';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';

import { getMyRunsColumnSettings, myRunsDefaultColumnsSettings } from '@neptune/home-page-domain';
import { getOrderedColumns, orderedColumnsSorter } from '@neptune/shared/columns-business-logic';
import { ColumnsRootKey } from '@neptune/shared/columns-domain';
import { LeaderboardColumn, leaderboardColumnFactory } from '@neptune/shared/leaderboard-domain';

import { AppState } from 'state/types';

const getNonEmptyColumnsSet = createSelector(
  [getOrderedColumns],
  (columns) => columns || myRunsDefaultColumnsSettings,
);

const getMyRunsColumns = (state: AppState, leaderboardId: string) => {
  return getNonEmptyColumnsSet(state, ColumnsRootKey.MyRuns, leaderboardId);
};

export const getMyRunsOrderedColumns = memoize(
  (id: string) =>
    createSelectorCreator(defaultMemoize, isEqual)(
      (state: AppState) => getMyRunsColumns(state, id),
      (columns: LeaderboardColumn[]) =>
        columns
          .map((col) =>
            leaderboardColumnFactory({ ...col, getColumnSettings: getMyRunsColumnSettings }),
          )
          .sort(orderedColumnsSorter),
    ),
  (id: string) => {
    return id;
  },
);
